import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class MarginsTransform extends EldmlTransform {
  apply() {
    this.selector.find("[margin]").each(function (_: any, element: Element) {
      const elementSelector = $(element);
      const currentStyle = elementSelector.attr("style") || "";
      const margin = elementSelector.attr("margin");
      elementSelector.attr("style", `${currentStyle} margin: ${margin};`);
    });
  }
}
